import { Spinner } from '../../../components';

export const LoadingSpinner = () => {
  return (
    <div className="flex flex-col items-center justify-center h-full">
      <Spinner width="120px" height="120px" />
      <span className="text-primary-200 text-sm font-bold">Loading...</span>
    </div>
  );
};
